import { IUserToken } from '.';

export interface IStore extends Record<string, unknown> {
  isAuthenticated: boolean;
  user: IUserToken | null;
  token: string | null;
  refreshToken: string | null;
}
